import scroll from 'smoothscroll-polyfill';

import {
  getHeaderAndSubnavHeight,
  getHeaderAndBuyBarHeight,
} from 'utils/getHeaderHeight';

scroll.polyfill();

export const scrollToTop = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: `smooth`,
  });
};

export const scrollToElement = (elem) => {
  const offset = elem.getBoundingClientRect().top + window.pageYOffset - getHeaderAndSubnavHeight();

  window.scroll({
    top: offset,
    left: 0,
    behavior: `smooth`,
  });
};

export const scrollToElementWithBuyBar = (elem) => {
  const offset = elem.getBoundingClientRect().top + window.pageYOffset - getHeaderAndBuyBarHeight();

  window.scroll({
    top: offset,
    left: 0,
    behavior: `smooth`,
  });
};
